import DotsLoader from './dots-loader';

export default DotsLoader;
